/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PermissionRoleWithOwnerEnum {
    ADMIN = 'admin',
    USER_ADMIN = 'userAdmin',
    KYC_ADMIN = 'kycAdmin',
    EDITOR = 'editor',
    EXPORT_VIEWER = 'exportViewer',
    VIEWER = 'viewer',
    OWNER = 'owner',
}
